<div class="no-data-item">
  <img src="../../assets/simpli/sin-data.svg" height="75px">
  <mat-label>{{text}}</mat-label>
</div>
